var _mask, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLeftTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 391,
    height: 371,
    viewBox: "0 0 391 371",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "left_top_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 391,
    height: 371
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M0 0h391v371H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#left_top_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -71,
    cy: -92,
    r: 355.5,
    stroke: "#81E1C1",
    strokeOpacity: 0.67,
    strokeWidth: 59
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -71,
    cy: -93,
    r: 423.5,
    stroke: "#F4F8FE",
    strokeOpacity: 0.08,
    strokeWidth: 77
  }))));
}

export default __webpack_public_path__ + "./fonts/left_top.5bb6633717f47b9a34001780f9b2ad74.svg";
export { SvgLeftTop as ReactComponent };